import { SidenavList } from '@app/models';

export const SidenavListConstants: SidenavList[] = [
  { title: 'My Day', link: 'home', icon: 'house', permissionKey: 'Home' },
  {
    title: 'Drivers',
    link: 'drivers',
    icon: 'truck',
    permissionKey: 'Drivers',
  },
  {
    title: 'Events',
    link: 'events',
    icon: 'triangle-exclamation',
    permissionKey: 'Events',
  },
  {
    title: 'Coaching',
    link: 'intervention/coaching',
    icon: 'book',
    permissionKey: 'Interventions',
  },
  {
    title: 'Recognition',
    link: 'recognition',
    icon: 'award',
    permissionKey: 'Driver Recognition',
  },
  {
    title: 'Tasks',
    link: 'tasks',
    icon: 'list-check',
    permissionKey: 'Qualification Files',
  },
  {
    title: 'Analytics',
    link: 'analytics',
    icon: 'chart-simple',
    children: [
      {
        title: 'Drivers',
        link: 'analytics-drivers',
        permissionKey: 'Driver Analytics',
      },
      {
        title: 'Events',
        link: 'analytics-events',
        permissionKey: 'Event Analytics',
      },
      {
        title: 'Intervention',
        link: 'analytics-intervention',
        permissionKey: 'Intervention Analytics',
      },
    ],
    permissionKey: 'Analytics',
  },
  {
    title: 'Settings',
    link: 'settings',
    icon: 'cog',
    permissionKey: 'Settings',
    children: [
      {
        title: 'Administration',
        link: 'administration',
        permissionKey: 'Admin Settings',
      },
      {
        title: 'Configuration',
        link: 'configuration',
        permissionKey: 'Configuration',
      },
      {
        title: 'System',
        link: 'system',
        permissionKey: 'System',
      },
      {
        title: 'Workflows',
        link: 'workflows',
        permissionKey: 'Workflow',
      },
    ],
  },
];
